import { Component, OnInit, ElementRef } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { NotificationService } from '../../../main/shared/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DialogOverviewExampleDialog } from 'src/app/main/smartcardtransactions/smartcardtransactions.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from 'src/app/main/login/login.service';
import { Loginmodel } from 'src/app/main/login/loginmodel';
import { first } from 'rxjs/operators';
import { Validations } from 'src/utility/validators';
import { RegisterService } from 'src/app/main/register/register.service';
import { Registermodel } from 'src/app/main/register/registermodel';
import { Result } from '../../result';
import { ForgotService } from 'src/app/main/forgot/forgot.service';
import { Forgotmodel } from 'src/app/main/forgot/forgotmodel';
import { UpdatefontsizeService } from '../../../services/updatefontsize.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  
  CurrentDate:string=formatDate(new Date(), 'dd/MM/yyyy', 'en');
  public isUser: Boolean = false;
  public language: string;
  public showBtnBack: boolean = false;
  public animal: any;
  public selected = '';
  public ShowLoginPopup: boolean = false;
  public ShowLogin: boolean = true;
  public loginLan : string;
  public logoutlan : string;
  public getLan: string;
  public registerLan: string;
  public  head: string;
  NmpmllogoLan: string;
  public citilincmobilelogo: string;
  info: string;
  loggingout: string;
  fontSize = 14;
  NASize = this.fontSize;

  constructor(private notifyService:NotificationService, 
    public router: Router, 
    public dialog: MatDialog, 
    private updateFont : UpdatefontsizeService,
    private authenticationService: AuthenticationService) {
    this.getLan = LocalstorageService.getLanguage('language');
  }

  ngOnInit() {
    this.language = LocalstorageService.getLanguage('language');
    if(this.getLan == 'en') {
      this.loginLan = "Login";
      this.logoutlan = "Logout";
      this.loggingout = "Logging out";
      this.info = "Info";
      this.registerLan = 'Register';
      this.head = 'Nashik Mahanagar Parivahan Mahamandal Limited';
      this.NmpmllogoLan = "../../../assets/images/webenglish.png";
      this.citilincmobilelogo = "../../../assets/images/Mobile_Englishmobilelogo.png"

    } else if (this.getLan == 'mr') {
      this.loginLan = "लॉगिन";
      this.registerLan = 'नोंदणी करा';
      this.logoutlan = "Logout";
      this.loggingout = "लॉग आउट";
      this.info = "माहिती";
      this.head = 'नाशिक महानगर परिवहन महामंडळ मर्यादित';
      this.NmpmllogoLan = "../../../assets/images/webmarathi.png";
      this.citilincmobilelogo = "../../../assets/images/Mobile_Marathimobilelogo.png"

    }

    if(LocalstorageService.getLocal('user') != null) {
      this.isUser = true;
      // this.openLoginDialog();
    } 
    this.setBackButton();
    
    //update font size daynamic
    this.updateFont.currentFontSource$.subscribe((type) => {
      if(type == '+'){
        if (this.fontSize < (this.NASize + 3)) {
          this.fontSize++;
        }
      } else if(type == '-'){
        if (this.fontSize > (this.NASize - 3)) {
          this.fontSize--;
        }
      } else{
          this.fontSize = this.NASize;
      }
    });
  }

  UpdateFontSize(e){ }

  logout() {
    LocalstorageService.logout('user');
    LocalstorageService.logout('user_NMC');
    localStorage.removeItem('currentUser');
    // this.currentUserSubject.next(null);
    this.notifyService.showInfo(this.loggingout,this.info);
    window.location.replace('/');
  }

  setBackButton() {
    var url = this.router.url;
    if(url == "/") {
      this.showBtnBack = false;
    } else {
      this.showBtnBack = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  openLoginDialog() {
    const dialogRef = this.dialog.open(LoginDialog);

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
      // if(JSON.parse(localStorage.getItem('currentUser')) == null){
      //   this.openLoginDialog();
      // }
    });
  }

  openRegisterDialog() {
    const dialogRef = this.dialog.open(RegisterDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openForgotPasswordDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  onLanguageChange(Language) {
    //alert(Language);
    LocalstorageService.setLanguage("language", Language);
    this.selected = Language;
    window.location.reload();
  }
}

@Component({
  selector: 'login.design.popup',
  templateUrl: 'login.design.popup.html',
})
export class LoginDialog {

  public urlName: string = "";
  public getLan: string;
  public rememberLan: string;
  public loginLan: string;
  public registerLan: string;
  public orLan: string;
  public forgotLan: string;
  public userLan: string;
  public passwordLan: string;
  public userModel: Loginmodel;
  public userid: any;
  public loginuser: string;
  LoginLanBtn: string;
  show: string;
  LoginAttemptMessage: string;
  isTextFieldType: boolean;
  fieldrequiredlan: string;
  info: string;
  error: string;
  usernotexist: string;
  succesfullogin: string;
  success: string;
  isChecked: boolean = false;

  constructor(public router: Router, private loginService: LoginService, private cookieService: CookieService,
    private notifyService: NotificationService, public dialog: MatDialog, private authenticationService: AuthenticationService) {
    this.getLan = LocalstorageService.getLanguage('language');
  
  }

  public editForm = new FormGroup({
    // EmailID: new FormControl(),
    MobileNo: new FormControl(),
    Password: new FormControl(),
  });
  
  ngOnInit() {
    
    this.urlName = LocalstorageService.getLocal('geturl');  //Getting Url Name From Dashboard
    if(this.getLan == 'en') {
      this.rememberLan = 'Remember Me';
      this.forgotLan = 'Forgot Password?';
      this.loginLan = 'Login';
      this.LoginLanBtn = 'LOGIN';
      this.registerLan = 'Register';
      this.orLan = 'OR';
      this.userLan = 'Enter Mobile No';
      this.passwordLan = 'Password';
      this.show = "Show";
      this.fieldrequiredlan = "All Fields Are Required.";
      this.info = "Info";
      this.error = "Error";
      this.LoginAttemptMessage = "You had unsuccessful login attempts for 5 times. Need to verify mobile number and reset password.";
      this.usernotexist = "User does not Exists.";
      this.succesfullogin = "Login Successful";
      this.success = "Success";
    } else if (this.getLan == 'mr') {
      this.rememberLan = 'माझी आठवण ठेवा';
      this.LoginAttemptMessage = "आपल्याकडे 5 वेळा लॉगिन प्रयत्न अयशस्वी झाले. मोबाइल नंबर सत्यापित करणे आणि संकेतशब्द रीसेट करणे आवश्यक आहे.";
      this.forgotLan = 'संकेतशब्द विसरलात?';
      this.loginLan = 'लॉगिन';
      this.error = "त्रुटी";
      this.LoginLanBtn = 'लॉगिन';
      this.registerLan = 'नोंदणी करा';
      this.orLan = 'किंवा';
      this.userLan = 'मोबाइल क्रमांक प्रविष्ट करा';
      this.passwordLan = 'संकेतशब्द';
      this.show = 'दाखवा';
      this.fieldrequiredlan = "सर्व फील्ड आवश्यक आहेत.";
      this.info = "माहिती";
      this.usernotexist = "वापरकर्ता विद्यमान नाही.";
      this.succesfullogin = "लॉगिन यशस्वी";
      this.success = "यश";
    } else {
      this.rememberLan = 'Remember Me';
      this.forgotLan = 'Forgot Password?';
      this.loginLan = 'Login';
      this.registerLan = 'Register';
      this.orLan = 'OR';
      this.userLan = 'Enter Mobile No';
      this.passwordLan = 'Password';
      this.fieldrequiredlan = "All Fields Are Required.";
      this.info = "Info";
    }

    var GetUser = this.cookieService.get('username');
    var GetPass = this.cookieService.get('password');
    if(GetUser != "" || GetPass != ""){
      this.editForm.controls.MobileNo.setValue(GetUser);
      this.editForm.controls.Password.setValue(GetPass);
      this.isChecked = true;
    }  
  }

  public checkLoginDetails(login: Loginmodel) {
    if (this.editForm.value.MobileNo == null || this.editForm.value.Password == null
      || this.editForm.value.MobileNo == "" || this.editForm.value.Password == "") { 
      this.notifyService.showInfo(this.fieldrequiredlan, this.info);
    } else {
      this.loginService.CheckLoginData(this.editForm.value).pipe(first()).subscribe(result => {
        this.userModel = (result);
        // console.log(result);
        this.userid = this.userModel.Userid;
        if (this.userModel.Userid != null) {
          LocalstorageService.setLocal('user', this.userid);   //Set the Userid In LocalStorage
          LocalstorageService.setLocal('mobileno', this.editForm.value.MobileNo);   // Set MobileNo In LocalStorage For SmartCard
          LocalstorageService.setLocal('user_NMC', this.userid);   //Set the Userid In LocalStorage
          LocalstorageService.setLocal('mobileno_NMC', this.editForm.value.MobileNo);
          LocalstorageService.setLocal('Token', result.token);
          this.authenticationService.currentUserSubject.next(result);
          localStorage.setItem('currentUser', JSON.stringify(result));
          
          var mobileno = LocalstorageService.getLocal('mobileno');
          if (this.urlName == null) {
            this.loginuser = LocalstorageService.getLocal('user');
            window.location.replace('/')
            LocalstorageService.removeURL('geturl');
          } else {
            this.router.navigate(['/' + this.urlName]);
            // window.location.replace(this.urlName);
            LocalstorageService.removeURL('geturl');
          }
          const dialogRef1 = this.dialog.closeAll();
          this.notifyService.showSuccess(this.succesfullogin, this.success);

        } else if(result.TotalLoginAttempt == "009" || result.TotalLoginAttempt == "008") {
          
          this.notifyService.showError(result.Messages, this.error);
          // this.openForgotPasswordDialog();
        } else if(result.TotalLoginAttempt == "007") {
          this.notifyService.showError(result.Messages, this.error);
        }
        else {
          this.notifyService.showError(this.userModel.message, this.usernotexist);
        }
      },
        err => {
          this.notifyService.showError(err, this.error);
        });
    }
  }

  togglePasswordFieldType(){
    this.isTextFieldType = !this.isTextFieldType;
  }

  openForgotPasswordDialog() {
    const dialogRef1 = this.dialog.closeAll();
    const dialogRef = this.dialog.open(ForgotPasswordDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  validateNumber(event) {
    const keyCode = event.keyCode;

    const excludedKeys = [8, 37, 39, 46];

    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
    }
  }

  checkValue(e){
    alert(e);
    if(e=='true'){
      this.cookieService.set('username',this.editForm.value.MobileNo);
      this.cookieService.set('password',this.editForm.value.Password);
    } else {
      this.cookieService.delete('username');
      this.cookieService.delete('password');
    }
  }
}

@Component({
  selector: 'register.design.popup',
  templateUrl: 'register.design.popup.html',
})
export class RegisterDialog {

  public resultData: Result;
  showOTP: boolean = false;
  getlen: string;
  userLan: string;
  passwordLan: string;
  birthLan: string;
  genderLan: string;
  emailLan: string;
  addressLan: string;
  mobileLan: string;
  conPassLan: string;
  registerLan: string;
  loginLan: string;
  OTPLan: string;
  EnterotpLan: string;
  submitLan: string;
  reqOTP: string;
  femaleLan: string;
  maleLan: string;
  public validations = Validations;
  submitted = false;
  registerLanBtn: string;
  info: string;
  fieldrequiredLan: string;
  error: string;
  passconpass: string;
  registername: string;
  warning: string;
  registermobno: string;
  registerdob: string;
  InvalidMobile: string;
  public disabled: boolean = false;
  
  constructor(private registerService: RegisterService, public router: Router, 
    private notifyService: NotificationService) { }

   

  ngOnInit() {
    this.getlen = LocalstorageService.getLanguage("language");
    if(this.getlen == 'en') {
      this.userLan = 'Name';
      this.birthLan = 'Date of Birth';
      this.genderLan = 'Gender';
      this.femaleLan='Female';
      this.maleLan='Male';
      this.emailLan = 'Email Id';
      this.addressLan = 'Address';
      this.mobileLan = 'Mobile No';
      this.passwordLan = 'Password';
      this.conPassLan = 'Confirm Password';
      this.registerLan = 'Register';
      this.loginLan = 'Back To Login';
      this.OTPLan = 'OTP will be sent to the registered mobile number';
      this.EnterotpLan = 'Enter OTP Code';
      this.submitLan = 'Submit';
      this.reqOTP = 'OTP Code is Required.';
      this.registerLanBtn = 'REGISTER';
      this.info = "Info";
      this.registername = "Name is required";
      this.warning = "Warning";
      this.registermobno = "Mobile No. is required";
      this.registerdob = "Date of Birth is required"
      this.fieldrequiredLan = "All Fields Are Required.";
      this.passconpass = "Password and Confirm Password need To Be Same..!!";
      this.error = "Error";
      this.InvalidMobile = "Invalid Mobile Number";
    }   else if (this.getlen == 'mr') {
      this.userLan = 'वापरकर्ता नाव';
      this.birthLan = 'जन्म तारीख';
      this.genderLan = 'लिंग';
      this.femaleLan='स्त्री';
      this.maleLan='पुरुष';
      this.emailLan = 'ई - मेल आयडी';
      this.addressLan = 'पत्ता';
      this.mobileLan = 'मोबाइल नं';
      this.passwordLan = 'पासवर्ड';
      this.conPassLan = 'पासवर्डची पुष्टी करा';
      this.registerLan = 'नोंदणी करा';
      this.loginLan = 'मागे करण्यासाठी लॉग-इन';
      this.OTPLan = 'OTP नोंदणीकृत मोबाइल क्रमांकावर पाठविला जाईल';
      this.EnterotpLan = 'OTP प्रविष्ट करा';
      this.submitLan = 'प्रस्तुत करणे';
      this.reqOTP = 'OTP आवश्यक आहे';
      this.registerLanBtn = 'नोंदणी करा';
      this.info = "माहिती";
      this.registername = "नाव आवश्यक आहे";
      this.warning = "चेतावणी";
      this.registermobno = "मोबाइल नंबर आवश्यक आहे";
      this.fieldrequiredLan = "सर्व फील्ड आवश्यक आहेत.";
      this.error = "त्रुटी";
      this.passconpass = "संकेतशब्द आणि पुष्टीकरण संकेतशब्द समान असणे आवश्यक आहे..!!";
      this.InvalidMobile = "Invalid Mobile Number";
    }
  }

  public disabledDates = (date: Date): boolean => {
    const currentDate = new Date();
    return date > new Date();
  }

  // onRegister(){
  //   //this.submitted = true;
  //     if(this.editForm.controls.Name.value == "" || this.editForm.controls.Name.value == undefined) {
  //       this.notifyService.showWarning(this.registername,this.warning);
  //     } else if(this.editForm.controls.MobileNo.value == "" || this.editForm.controls.MobileNo.value == undefined) {
  //       this.notifyService.showWarning(this.registermobno,this.warning);
  //     } 
  //     // else if(this.editForm.controls.remarks.value == "" || this.editForm.controls.remarks.value == undefined) {
  //     //   this.notifyService.showWarning(this.problemdescription,this.warning);
  //     // } else if(this.editForm.controls.feedbackdate.value == "" || this.editForm.controls.feedbackdate.value == undefined) {
  //     //   this.notifyService.showWarning(this.ratingdate ,this.warning);
  //     // } 
  //     // else {
  //     //   this.SubmitData();
  //     // }
  //     // this.isLoadingHome = false;
  //     // this.submitted = false;
  //     // this.valid = 1;
  // }

  public editForm = new FormGroup({
    Name: new FormControl("", this.validations.isAlphaRequired()),
    Address: new FormControl("",this.validations.isRequired()),
    DOB: new FormControl(),
    MobileNo: new FormControl("",this.validations.isValidMobile()),
    Gender: new FormControl("male"),
    Password: new FormControl("",this.validations.isAlphaNumericRequired()),
    EmailID: new FormControl("",this.validations.isValidEmail()),
    ConPassword: new FormControl("",this.validations.isAlphaNumericRequired()),
    otpcode: new FormControl()
  });

  public UserDetails(register: Registermodel) {
    //Checking That All Field Need To Be Fill
    debugger;
    this.disabled = true;
    this.submitted = true;
    if(this.editForm.controls.Name.value == "" || this.editForm.controls.Name.value == undefined) {
      this.notifyService.showWarning(this.registername,this.warning);
      this.disabled = false;
    }
    else if(this.editForm.controls.DOB.value == "" || this.editForm.controls.DOB.value == undefined) {
      this.notifyService.showWarning(this.registerdob,this.warning);
      this.disabled = false;
    } 
     else if(this.editForm.controls.MobileNo.value == "" || this.editForm.controls.MobileNo.value == undefined) {
      this.notifyService.showWarning(this.registermobno,this.warning);
      this.disabled = false;
    } else if (this.editForm.controls.MobileNo.value.length > 10) {
      this.notifyService.showWarning(this.InvalidMobile,this.warning);
      this.disabled = false;
    }
    
    else if (this.editForm.controls.Password.value == "" && this.editForm.controls.ConPassword.value == "") {
        if(this.getlen == 'en') {
          this.notifyService.showInfo("All Fields Are Required.", 'Info');
          this.disabled = false;
        } else if (this.getlen == 'mr') {
          this.notifyService.showInfo("सभी फ़ील्ड आवश्यक हैं.", 'Info');
          this.disabled = false;
        }
        this.disabled = false;
    }
    else {
      //Validating Password and Confirm Password
      if(this.editForm.controls.Password.value != this.editForm.controls.ConPassword.value) {
        if(this.getlen == 'en') {
          this.notifyService.showError(this.passconpass, 'Error');
          this.disabled = false;
        } else if (this.getlen == 'mr') {
          this.notifyService.showError(this.passconpass, 'Error');
          this.disabled = false;
        }
        this.disabled = false;
      }
      else {
        //Backend Call -- Calling Services
        this.registerService.NewRegister(this.editForm.value).pipe(first()).subscribe(result => {
          debugger
         // this.resultData = JSON.parse(result.data);
          this.resultData = result.data;
          // console.log(this.resultData);
          if(this.resultData[0]["res"] == "9"){
            debugger
            if(this.getlen == 'en') {
              this.notifyService.showError("This Mobile No is Already Registered.", 'Error');
            } else if (this.getlen == 'hi') {
              this.notifyService.showError("यह मोबाइल नंबर पहले से पंजीकृत है.", 'Error');
            } else if (this.getlen == 'mr') {
              this.notifyService.showError("हा मोबाईल नंबर आधीच नोंदणीकृत आहे.", 'Error');
            } else {
              this.notifyService.showError("This Mobile No is Already Registered.", 'Error');
            }
            
           // this.notifyService.showError(result.message, 'Error');
            this.disabled = false;
          } else if(this.resultData[0]["res"] == "8"){
            this.notifyService.showError(result.message, 'Error');
            this.disabled = false;
          } else if(this.resultData[0]["res"] == "1"){ 
            //this.notifyService.showSuccess(result.message, 'Success');
            this.showOTP = true;
            this.disabled = false;
          }
        });
      }
    }
  }

  public CheckOTP(register: Registermodel) {
    debugger
    this.disabled = true;
    if (this.editForm.controls.otpcode.value != null) {
      this.registerService.getOTP(this.editForm.value).pipe(first()).subscribe(result => {
        if (result.data[0]["status"] != 1) {
          this.notifyService.showInfo(result.data[0]["message"], 'Info');
          this.disabled = true;
        } else {
          this.notifyService.showSuccess(result.data[0]["message"], 'Success');
          //this.router.navigate(['/Login']);
        }
      });
    } else {
      this.notifyService.showInfo(this.reqOTP, 'Info');
      this.disabled = false;
    }
  }
}

@Component({
  selector: '[forgotpassword.popup]',
  // selector: '[appPassword]',
  templateUrl: 'forgotpassword.popup.html',
})
export class ForgotPasswordDialog {

  // @ViewChild(ShowHideInput) input: ShowHideInput;
  
  public userLan: string;
  public EnterotpLan: string;
  public EnterOTP: boolean = false;
  public EnterPassword: boolean = false;
  public LoginLanBtn: string;
  public reqOTP: string;
  public ReqConfPass: string;
  public ReqPass: string;
  public ForgotPasswordModel: Forgotmodel;
  public Password: string;
  public ConfPassword: string;
  public getLan: string;

  public editForm = new FormGroup({
    // EmailID: new FormControl(),
    mobile_no: new FormControl(),
    otpcode: new FormControl(),
    newpassword: new FormControl(),
    conPassword: new FormControl()
  });
  language: string;
  otp: any;
  ShowLogin: boolean;
  ForgotPassLan: string;
  MobileNoReq: string;
  isTextFieldType: boolean;
  isTextFieldTypeCon: boolean;
  info : string;
  error: string;
  sendoptLan: string;
  mobilenotexist: string;
  usernotexist: string;
  isConTextFieldType: boolean;
  show: boolean;
  
  constructor(public ForgotService: ForgotService, private notifyService: NotificationService) {
    this.getLan = LocalstorageService.getLanguage('language');
  }

  ngOnInit() {
    this.language = LocalstorageService.getLanguage('language');
    if(this.language == null) {
      this.language = 'en';
    }

    if(this.getLan == 'en') {
      this.userLan = "Enter Mobile No";
      this.EnterotpLan = "Enter OTP";
      this.LoginLanBtn = "SUBMIT";
      this.reqOTP = "OTP Code is Required.";
      this.MobileNoReq = "Mobile Number Required";
      this.info = "Info";
      this.error = "Error"; 
      this.sendoptLan = 'OTP will be sent to the registered Mobile No';
      this.ReqConfPass = "Confirm Password Required";
      this.Password = "Enter New Password";
      this.ConfPassword = "Enter Confirm Password";
      this.ForgotPassLan = "Forgot Password";
      this.ReqPass = "Password and confirm password should be same..!!";
      this.mobilenotexist = "Mobile No doesn't exist";
      this.usernotexist = "User doesn't exist";
    } else if(this.getLan == "mr") {
      this.MobileNoReq = "मोबाइल नंबर आवश्यक";
      this.info = "माहिती";
      this.sendoptLan ="नोंदणीकृत मोबाईल नंबरवर ओटीपी पाठवला जाईल";
      this.ReqConfPass = "संकेतशब्द आवश्यक असल्याची पुष्टी करा";
      this.reqOTP = "ओटीपी आवश्यक";
      this.userLan = "मोबाइल नं प्रविष्ट करा";
      this.EnterotpLan = "OTP प्रविष्ट करा";
      this.Password = "नवीन संकेतशब्द प्रविष्ट करा";
      this.ConfPassword = "पुष्टीकरण संकेतशब्द प्रविष्ट करा";
      this.LoginLanBtn = "प्रस्तुत करणे";
      this.ForgotPassLan = "पासवर्ड विसरला";
      this.error = "त्रुटी";
      this.ReqPass = "संकेतशब्द आणि पुष्टीकरण संकेतशब्द समान असावा..!!";
      this.mobilenotexist = "मोबाइल नंबर अस्तित्त्वात नाही";
      this.usernotexist = "वापरकर्ता विद्यमान नाही";
    } else {
      this.userLan = "Enter Mobile No";
      this.EnterotpLan = "Enter OTP";
      this.LoginLanBtn = "SUBMIT";
      this.sendoptLan = 'OTP will be sent to the registered Mobile No';
      this.ForgotPassLan = "Forgot Password";
    }
    this.ShowLogin = true;
  }

  CheckUserDetails(event) {
    var d = this.editForm.controls.mobile_no.value;
    if(this.editForm.controls.mobile_no.value != null) {
      //this.ForgotPasswordModel.mobile_no = this.editForm.controls.mobile_no.value; 
      this.ForgotService.CheckEmail(this.editForm.value).pipe(first()).subscribe(result => {
        //console.log(result.data[0].otpcode);
        this.otp = (result.data[0].otpcode);
        if (result.data[0].status == 1) {
          this.ShowLogin = false;
          this.EnterOTP = true;
        }
        else if(result.data[0].status == 0){
          this.notifyService.showError(this.mobilenotexist, this.error);
        }
      },
      err => {
        if(err.message==""){
          this.notifyService.showError(this.usernotexist, this.error);
        }
        else{
          this.notifyService.showError(err, this.error);
        }
      });
    } else {
      this.notifyService.showInfo(this.MobileNoReq, this.info);
    }
  }

  CheckOTP(event) {
    debugger
    if(this.editForm.controls.otpcode.value != null) {
      this.ForgotService.CheckOTP(this.editForm.value).pipe(first()).subscribe(result => {
        if (result.data[0].status == 1) {
          this.notifyService.showInfo(this.sendoptLan, 'Info');
          this.EnterOTP = false;
        this.ShowLogin = false;
        this.EnterPassword = true;
        } 
      },
      err => {
        this.notifyService.showError(err, 'Error');
      });
    } else {
      this.notifyService.showInfo(this.reqOTP, this.info);
    }
  }
  
  togglePasswordFieldType(e){
    if(e == 1)
      this.isTextFieldType = !this.isTextFieldType;
    else
      this.isTextFieldTypeCon = !this.isTextFieldTypeCon;
  }

  toggleConfPasswordFieldType(){
    this.isConTextFieldType = !this.isConTextFieldType;
  }
  ResetPassword(){
    debugger;
    if(this.editForm.controls.newpassword.value == null ||  this.editForm.controls.newpassword.value == '' ||
    this.editForm.controls.conPassword.value == null ||  this.editForm.controls.conPassword.value == '') {
      
      this.notifyService.showError(this.ReqConfPass, this.error);

    } else {
      if (this.editForm.controls.newpassword.value  == this.editForm.controls.conPassword.value) {
        this.ForgotService.ResetPassword(this.editForm.value).pipe(first()).subscribe(result => {
          if (result.data[0].status == 1) {
            this.notifyService.showSuccess(result.data[0].message, 'Success');
            //this.router.navigate(['/Login']);
          }
        },err => {
          this.notifyService.showError(err, 'Error');
        });
      } else {
        this.notifyService.showError(this.ReqPass, this.error);
      }
    }
  }

  checkNumberFieldLength(elem){
    if (elem.value.length > 4) {
      elem.value = elem.value.slice(0,4); 
    }
  }

  validateNumber(event) {
    const keyCode = event.keyCode;

    const excludedKeys = [8, 37, 39, 46];

    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
      // event.pattern('[6-9]\\d{2}');
    }

    // return Validators.compose([
    //   Validators.pattern('[6-9]\\d{9}')
    // ]);
  }
 
}
